export function dateLogic(data, key, localizedStrings) {
  if (
    data.start_date_month !== "" &&
    data.start_date_year !== "" &&
    data.end_date_month !== "" &&
    data.end_date_year !== "" &&
    data.start_date_month !== null &&
    data.start_date_year !== null &&
    data.end_date_month !== null &&
    data.end_date_year !== null
  ) {
    const startDate = parseInt(
      data?.start_date_year + data?.start_date_month?.padStart(2, "0"),
      10,
    ); // Combine and ensure MM format
    const finishDate = parseInt(
      data?.end_date_year + data?.end_date_month?.padStart(2, "0"),
      10,
    ); // Combine and ensure MM format

    if (startDate > finishDate) {
      return localizedStrings.applicationpage.finishYearError;
    }
    if (
      (key === 5 || key === 6) &&
      data.usb_graduationdate &&
      data.usb_graduationdate !== ""
    ) {
      const graduationYear = parseInt(data?.usb_graduationdate, 10); // Extract year from graduation date (format: YYYY-MM-DD)
      const finishYear = parseInt(data?.end_date_year, 10);

      // Check if graduationYear is before finishYear
      if (graduationYear < finishYear) {
        // Only apply the additional condition for key === 6
        if (key === 6 && data.usb_currentdegreestatus !== 943240001) {
          return;
        }
        return localizedStrings.applicationpage.graduationYearError;
      }
    }

    // Clear error message if all validations pass
    return "";
  }
}
